export default __webpack_public_path__ + "static/media/approved.b6511572.svg";